/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface StationPingDto
 */
export interface StationPingDto {

    /**
     * Server clock (epoch ms) when the request entered the backend, before any guard ran.
     *
     * @type {number}
     * @memberof StationPingDto
     * @example 1790000000123
     */
    serverReceivedAt: number;

    /**
     * Server clock (epoch ms) when the response was built. Minus serverReceivedAt, it is the time spent inside the backend.
     *
     * @type {number}
     * @memberof StationPingDto
     * @example 1790000000131
     */
    serverSentAt: number;
}
